import { BitkitLink, BitkitRibbon } from '@bitrise/bitkit-v2';
import { useContext, useEffect } from 'react';

import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import RestrictedPlanBuildUpsellDialog from '@/components/RestrictedPlanBuildUpsellDialog/RestrictedPlanBuildUpsellDialog';
import useRestrictedPlanBuildUpsell from '@/components/RestrictedPlanBuildUpsellDialog/useRestrictedPlanBuildUpsell';
import { CardVerificationContext } from '@/hooks/analytics/cardVerificationTracking';
import loadChargebeeScript from '@/utils/loadChargebeeScript';
import { planSelectorPagePath } from '@/utils/monolithApiRouteService';

const CARD_VERIFICATION: CardVerificationContext = {
  source: 'global_header_banner',
  reason: 'trial_start',
  productName: 'ci',
};

const WelcomeBanner = () => {
  const { account } = useContext(GlobalPropsContext);
  useEffect(() => {
    loadChargebeeScript().catch(() => {});
  }, []);
  const { isUpsellDialogOpen, onUpsellDialogOpen, onUpsellDialogClose, organizationSlug } =
    useRestrictedPlanBuildUpsell();

  return (
    <>
      <BitkitRibbon
        colorVariant="green"
        action={{ label: 'Activate Pro trial', onClick: onUpsellDialogOpen }}
        title={account?.isHobby ? "You're on the Hobby plan." : "You're on our limited trial."}
      >
        Activate your free 30-day Pro trial for more builds &amp; faster machines, or{' '}
        <BitkitLink href={planSelectorPagePath(organizationSlug)} textDecoration="underline">
          choose another plan
        </BitkitLink>{' '}
        at any time.
      </BitkitRibbon>
      <RestrictedPlanBuildUpsellDialog
        isOpen={isUpsellDialogOpen}
        organizationSlug={organizationSlug}
        onClose={onUpsellDialogClose}
        cardVerification={CARD_VERIFICATION}
      />
    </>
  );
};

export default WelcomeBanner;
